<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormFarm
      :Farm="editFarm"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormFarm from '../components/FormFarm.vue';

export default {
  components: {
    FormFarm,
  },
  name: 'EditFarm',
  module: 'Farm',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing Farm. Default to {}.
      */
      editFarm: {},
      /**
       * Query Id for Farm
       */
      farmId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('farms', ['farms', 'farm']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.farmId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_farm(this.farmId);
      this.editFarm = this.farm;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('farms', ['LOAD_farm', 'CREATE_farm', 'UPDATE_farm']),
    /** Method used to save the item
     */
    async save(farm) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_farm(farm);
      } else {
        await this.UPDATE_farm(farm);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListFarm' });
    },
  },
};
</script>

<docs>
# EditFarm example

'''js
<EditFarm :Farm="Farm" />
'''
</docs>
